import { useMemo } from "react";

import { SECTION_FILL_CLASSES } from "components/sidebar/sidebarShell";
import AttendancesTable from "routes/swoogo/AttendancesTable";
import RegistrantsTable from "routes/swoogo/RegistrantsTable";
import SessionsTable from "routes/swoogo/SessionsTable";
import { useReadableSwoogoSections } from "routes/swoogo/swoogoSections";

const TABLES = {
  sessions: SessionsTable,
  registrants: RegistrantsTable,
  attendances: AttendancesTable,
};

/**
 * Builds one detail page section per Swoogo table the user can read, in the
 * given order, each table limited to one record. Label, icon and read
 * permission come from the sidebar definition, so the two cannot drift.
 */
const useRecordTableSections = (tableKeys, scopeKey, recordId) => {
  const readableSections = useReadableSwoogoSections();
  const scope = useMemo(() => ({ [scopeKey]: recordId }), [scopeKey, recordId]);

  return tableKeys.flatMap(key => {
    const section = readableSections.find(readable => readable.key === key);
    if (!section) {
      return [];
    }
    const Table = TABLES[key];
    return [
      {
        key,
        label: section.label,
        icon: section.icon,
        content: (
          <div className={SECTION_FILL_CLASSES}>
            <Table scope={scope} />
          </div>
        ),
      },
    ];
  });
};

export default useRecordTableSections;
